import script from "./cjmfs_sk.vue?vue&type=script&setup=true&lang=js"
export * from "./cjmfs_sk.vue?vue&type=script&setup=true&lang=js"

import "./cjmfs_sk.vue?vue&type=style&index=0&id=4549cfb0&lang=less"

const __exports__ = script;

export default __exports__